module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag18_0855AT.1786a986.jpg";